import Button from "@ui-components/Button";
import Icon from "@ui-components/Icon";

const redirecToEuAct = () => {
    window.open("https://artificialintelligenceact.eu/assessment/eu-ai-act-compliance-checker/", "_blank");
};

const HomeButton = ({ iconName, label, onClick }) => (
    <Button
        variant="contained"
        color="primary"
        onClick={onClick}
    >
        <Icon
            iconName={iconName}
            className="mr-2 h-[21px] w-[21px]"
        />
        {label}
    </Button>
);

const Body = ({ backgroundColor, image, imagePosition, text }) => (
    <div
        className={`flex flex-col ${imagePosition === "right" ? "md:flex-row-reverse" : "md:flex-row"} 
  items-center justify-center p-6 md:gap-24
  ${backgroundColor === "blue" ? "bg-am-600 text-white" : "bg-white text-black"}`}
    >
        {image && (
            <img
                src={image}
                alt="Component"
                className="w-full max-w-xs md:max-w-[20%] h-auto object-cover"
            />
        )}
        <div className="text-xl font-light w-full md:w-[30%] text-center">
            {text}
        </div>
    </div>


);

const Features = ({ features }) => (
    <div className="flex flex-col items-center mt-10 ml-[5%] mr-[5%] mb-10">
        <p className="text-2xl font-extrabold text-center mb-10">HEAT FEATURES</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map(({ text, image_path }, i) => (
                <div
                    key={i}
                    className="hover:scale-105 transform transition-transform duration-300 flex flex-col items-center justify-between p-6 border border-am-600 rounded-3xl shadow-md hover:shadow-lg transition-all"
                >
                    <p className="text-xl font-bold text-am-500 text-center mb-4">{text}</p>
                    <img src={image_path} alt={text} className="w-2/3 h-auto" />
                </div>
            ))}
        </div>
    </div>
);



const HomeContent = ({ exploreTemplate = undefined }) => {

    return (
        <>
            <div className="flex flex-col items-center justify-center m-10 pb-10 mb-5 mx-2 ">
                <div className="text-5xl text-center leading-relaxed pb-2">
                    <i>Hello</i> and <i>welcome</i> to
                    <br />
                    <b>H</b>igh-risk <b>E</b>U <b>A</b>IAct <b>T</b>oolkit
                </div>
                <img
                    src="/HomePageImages/four_dots.png"
                    alt=""
                    className="w-[20%] md:w-[15%] lg:w-[10%]"
                />
            </div>

            <div className="flex flex-col items-center justify-center mb-10 lg:mx-[20%]">
                <div className="w-full aspect-video">
                    <iframe
                        title="homePageVideo"
                        className="w-full h-full"
                        src="https://www.youtube.com/embed/jTpR7nLJAK4"
                        allowFullScreen
                    />
                </div>
                <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8 justify-around w-full mt-10 mx-2">
                {exploreTemplate && <HomeButton
                        iconName="MagnifyingGlassIcon"
                        className="h-11 w-11"
                        label={'explore the template'}
                        onClick={exploreTemplate}
                    />}
                    <a href="/pdf_folder/HEAT_High_risk_EU_AiAct_Toolkit.pdf" download="HEAT_High_risk_EU_AiAct_Toolkit.pdf">
                        <HomeButton
                            iconName="ArrowDownTrayIcon"
                            className="h-11 w-11"
                            label={'download heat guide'}
                        />
                    </a>
                </div>
            </div>

            {data.map((item, index) => (
                <Body
                    key={index}
                    backgroundColor={item.backgroundColor}
                    image={item.image}
                    text={item.text}
                    imagePosition={item.imagePosition}
                />
            ))}

            <Features features={features} />

            <div className="flex flex-col items-center mt-10 ml-[5%] mr-[5%] mb-10">
                <p className="text-2xl font-black">DISCOVER MORE ABOUT YOUR IA</p>
                <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8 justify-around w-full mt-10 mx-2">
                    <HomeButton
                        iconName="LinkIcon"
                        className="h-11 w-11"
                        label={'does my ai fall into the high-risk category'}
                        onClick={redirecToEuAct}
                    />
                    <a href="/pdf_folder/HEAT_EU_AIAct.pdf" download="HEAT_EU_AIAct.pdf">
                        <HomeButton
                            iconName="EyeIcon"
                            className="h-11 w-11"
                            label={'explore european artificial intelligence act'}
                        />
                    </a>
                </div>
            </div>
        </>
    );
}

export default HomeContent;

const data = [
    {
        backgroundColor: 'blue',
        image: '/HomePageImages/red_white_lines.png',
        text: (
            <>
                We guide you through the mandatory documentation from risk management and data governance, to the <i>Declaration of Conformity.</i>
            </>
        ),
        imagePosition: 'right',
    },
    {
        backgroundColor: 'white',
        image: '/HomePageImages/home_page_eyes.png',
        text: (
            <>
                Ultimately, we also hope to make it easier for citizens to understand what high risk AI is, how it affects their rights and impacts to society.
            </>
        ),
        imagePosition: 'left',
    },
    {
        backgroundColor: 'blue',
        image: '/HomePageImages/home_page_triangles.png',
        text: (
            <>
                You're upskilling yourself with the latest AI ethics techniques. It's about bringing the EU AI Act to life through your business's values.
            </>
        ),
        imagePosition: 'right',
    },
    {
        backgroundColor: 'white',
        image: '/HomePageImages/home_page_rectangles.png',
        text: (
            <>You're upskilling yourself with the latest AI ethics techniques. It's about bringing the EU AI Act to life through your business's values.</>
        ),
        imagePosition: 'left',
    },
];

const features = [
    {
        text: "SPACES AND TASKS",
        image_path: "/HomePageImages/home_tree_graph.png",
    },
    {
        text: "NO LINEAR PROCESS",
        image_path: "/HomePageImages/home_one_side_graph.png",
    },
    {
        text: "GUIDANCE AND ACTION POINTS",
        image_path: "/HomePageImages/home_circle.png",
    },
    {
        text: "REVIEW AND EVALUATION",
        image_path: "/HomePageImages/home_geometric_forms.png",
    },
];
